import React from 'react';
import '../stylesheets/AnalisisTabs.css';

const AnalisisTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="analysis-tabs-container">
      <button
        className={`tab-btn ${activeTab === 'basico' ? 'active' : ''}`}
        onClick={() => setActiveTab('basico')}
      >
        Análisis Básico
      </button>
      <button
        className={`tab-btn ${activeTab === 'profundo' ? 'active' : ''}`}
        onClick={() => setActiveTab('profundo')}
      >
        Análisis Profundo
      </button>
      <button
        className={`tab-btn ${activeTab === 'filtros' ? 'active' : ''}`}
        onClick={() => setActiveTab('filtros')}
      >
        Filtros Manuales
      </button>
    </div>
  );
};

export default AnalisisTabs;